import styled from 'styled-components';

const SecondaryHeader = styled.div`
  background-color: ${(props) => props.theme.colors.light_peach}33;
  font-family: ${(props) => props.theme.fonts.grosa};
  color: ${(props) => props.theme.colors.brown};
  padding-top: 180px;
  padding-bottom: 135px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding-top: 95px;
    padding-bottom: 70px;
  }

  h1 {
    font-size: 85px;
    font-weight: 300;
    line-height: 90px;
    text-align: center;
    letter-spacing: -0.03em;
    padding-bottom: 25px;

    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      font-size: 40px;
      line-height: 55px;
      letter-spacing: -0.02em;
    }
  }

  p {
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    opacity: 0.8;
  }
`;

export default SecondaryHeader;
